import React from 'react';
import '../styles/LoginPage.css';

function LoginPage() {
  const handleRedirect = () => {
    window.location.href = 'https://www.gpworld.fr';
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-card">
          <h1>🎵 Disney Music Collection</h1>
          <p>Vous devez être connecté à DLPMUSIC pour accéder à cette application.</p>
          
          <button onClick={handleRedirect} className="login-btn">
            Se connecter via DLPMUSIC
          </button>

          <div className="login-info">
            <p>Cette application utilise l'authentification de DLPMUSIC.</p>
            <p>Si vous êtes déjà connecté, veuillez rafraîchir la page.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
